import axios from 'axios';
import { HttpMethod } from "./enums.js";


export class AxiosUtil {

  static createAxiosInstance(apiUrl, timeout = 1000 * 60) {
    return axios.create({
      baseURL: apiUrl,
      timeout: timeout, 
    });
  }

  static async request(apiUrl, method, url, body = {}, headers = {}, params = {}) {

    const axiosInstance = this.createAxiosInstance(apiUrl);

    const config = {
      url: url,
      method: method,
      headers: headers,
      data: body,
      params: method === HttpMethod.GET ? params : undefined,
    };

    const response = await axiosInstance(config);

    return response;
  }
}


